import { render, staticRenderFns } from "./choose-identity.vue?vue&type=template&id=70e073ac&scoped=true"
import script from "./choose-identity.vue?vue&type=script&lang=js"
export * from "./choose-identity.vue?vue&type=script&lang=js"
import style0 from "./choose-identity.vue?vue&type=style&index=0&id=70e073ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e073ac",
  null
  
)

export default component.exports